import React  from "react";

// Loading: Componente que renderiza los puntos de Cargando..

const Loading = ({ top, left }) => {
    let TOP = top || "50%";
    let LEFT = left || "50%"; 

    return (

        <div className="gooey" style={{top: TOP, left: LEFT}}>
            <span className="dot"></span>
            <div className="dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

    )
};

export default Loading;